import { useContext } from 'react';
import { AbsenceApplicationContext } from '@/components/AbsenceApplication/context';

export const useAbsenceApplication = () => {
  const context = useContext(AbsenceApplicationContext);

  if (!context) {
    throw new Error(
      'useAbsenceApplication must be used inside AbsenceApplicationProvider',
    );
  }

  return context;
};
